
  import {Component, Prop, Watch, Vue} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  import { Reporte } from "@/addons/Reporte";
  import HeadReport from "@/components/HeadReport.vue";
  
  @Component({
    name: "FormInsumo",
    components: {HeadReport}
  })
  export default class FormInsumo extends Vue {
    @Prop() dialog!: boolean
    @Prop() cotizacion_selected!: object
    @Prop() swEditar!: boolean
    @Prop() swVer!: boolean


    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
		otro_tratamiento = '';
		precio_unitario = 0;
		cantidad = 1;
		piezas = ''
		tratamiento = null
		detalles = []

    cotizacion = {
      id: null,
      nombre_paciente: '',
      edad_paciente: '',
      especialidad: '',
      
    };
    valid = true;
    
   
    mounted(){
			this.consultorioService.getTratamientos();
      console.log(this.swEditar)
      setTimeout(this.cargarDatos,1500);
    }
    
    close(){
      this.limpiar();
      this.$emit("close");
    }
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Llene todos los campos obligatorios (*)`)
          return;
        }
			let data = {
				id: this.cotizacion.id,
				nombre_paciente: this.cotizacion.nombre_paciente,
				edad_paciente: this.cotizacion.edad_paciente,
				especialidad: this.cotizacion.especialidad,
				detalles: this.detalles
			}
      if(!this.swEditar){
        Alert.confirm(`Se registrará la cotización del paciente ${this.cotizacion.nombre_paciente} `, 'Registrar cotización?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.storeCotizacion(data).then(response =>{
              //this.limpiar()
              this.$emit('close')
              this.$emit('listar')
            })
            
          }
        })
      }else {
        Alert.confirm(`Se realizará la modificacion de la cotización`, 'Modificar cotización?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.updateCotizacion(data)
            this.$emit('close')
            this.$emit('listar')
          }
        })
      }
      
    }
    cargarDatos(){
      console.log(this.swEditar)
      if(this.swEditar == false){
        this.limpiar()
        return
      }
      console.log('cargar')
      if( Object.entries(this.cotizacion_selected).length !== 0 && this.cotizacion_selected.constructor === Object){
        //this.swEditar = false;
        console.log('entra')
        this.cotizacion = {
          id: this.cotizacion_selected.id,
          nombre_paciente: this.cotizacion_selected.nombre_paciente,
          edad_paciente: this.cotizacion_selected.edad_paciente,
          especialidad: this.cotizacion_selected.especialidad,
          
        };
        this.cotizacion_selected.detalle.forEach(element => {
          this.detalles.push({
            tratamiento_id: element.tratamiento_id,
            tratamiento: element.tratamiento.nombre,
            otro_tratamiento: element.otro_tratamiento,
            precio: element.costo_unitario,
            cantidad: element.cantidad,
            piezas: element.piezas,
            subtotal: element.subtotal
          })
        });
      }
    }
    limpiar(){
      this.cotizacion = {
      id: null,
      nombre_paciente: '',
      edad_paciente: '',
      especialidad: '',
      
    };
    }
		agregarItem(){
			this.detalles.push({
				tratamiento_id: this.tratamiento.id,
				tratamiento: this.tratamiento.nombre,
				otro_tratamiento: this.otro_tratamiento,
				precio: this.precio_unitario,
				cantidad: this.cantidad,
				piezas: this.piezas,
				subtotal: Number(this.precio_unitario * this.cantidad).toFixed(2)
			})
      this.tratamiento = null;
      this.otro_tratamiento = '';
      this.cantidad = 1;
      this.piezas = '';
      this.precio_unitario = 0;
			console.log('agergar  item')
		}
		selectTratamiento(){
			if(this.tratamiento){
				console.log(this.tratamiento)
				this.precio_unitario = this.tratamiento.costo
			}
		}
    quitarItem(index:number){
    this.detalles.splice(index, 1)
  }
  imprimir() {
    const css = ".print table {border-collapse: collapse} .print td {padding:0.5 !important; font-size: xx-small !important;}"
    const p = new Reporte('area_impresion');
    p.orientacion ='vertical';
    p.otroCss = css;
    p.imprimir();
  }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
		get tratamientos(): any {
      return this.consultorioStore.tratamientos;
    }
    get total(): any {
      let total = 0;
      this.detalles.reduce((sum, val) => {
        total = total + Number(val.subtotal)
      },0)
      return total.toFixed(2);
    }
    
  }
  